import React, { useRef } from 'react';
import IdealTImer from 'react-idle-timer';
import { useHistory, useLocation } from 'react-router-dom';
import { useGlobalDispatch } from '../contexts';

const IdealTimer = () => {
  const time = process.env.REACT_APP_ENV === 'development' ? 60 * 60 * 60 * 1000 : 5 * 60 * 1000;

  const idleTimerRef:any = useRef(null);
  const { push } = useHistory();
  const { pathname, search } = useLocation();
  const { clearUser } = useGlobalDispatch();

  const shouldNotLogUserOut = [
    '/',
    '/forgot-password',
    '/password-reset',
  ];

  const handleOnIdeal = () => {
    if (!shouldNotLogUserOut.includes(pathname)) {
      clearUser();
      push('/');
      localStorage.setItem('userLocation', `${pathname}${search}`);
    }
  };

  return (
    <div>
      <IdealTImer ref={idleTimerRef} timeout={time} onIdle={handleOnIdeal} />
    </div>
  );
};
export default IdealTimer;
